import { render, staticRenderFns } from "./MaterialMgmt.vue?vue&type=template&id=4073c877"
import script from "./MaterialMgmt.vue?vue&type=script&lang=js"
export * from "./MaterialMgmt.vue?vue&type=script&lang=js"
import style0 from "./MaterialMgmt.vue?vue&type=style&index=0&id=4073c877&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports